export const DEVICE_CATEGORIES = {
    WEIGHT_SCALE: 'weight_scale',
    BLOOD_SUGAR_METER: 'bg_meter',
    BLOOD_PRESSURE_MONITOR: 'bp_monitor',
};

const {WEIGHT_SCALE, BLOOD_SUGAR_METER, BLOOD_PRESSURE_MONITOR} =
    DEVICE_CATEGORIES;

export default {
    [BLOOD_SUGAR_METER]: {
        mixpanelToggleEvent: 'bg.meter.cta.clicked',
        devices: [
            {
                id: 'bg300',
                image: 'member-portal/user-guides/bg300_device_flex_nextgen_zrtpdr',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/g8bmc83y',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/c96ot5e3',
                    },
                    {
                        id: 'ownersManual',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/8ear4yrr',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/ck7xnvns',
                    },
                    {
                        id: 'featuresGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/62qy2j31',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/zlhehadl',
                    },
                    {
                        id: 'instructions',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/uy8pg3wgf',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/44nnay8y',
                    },
                    {
                        id: 'howTo',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/j1zalusx',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/l4t80r7h',
                    },
                ],
            },
            {
                id: 'bg500',
                image: 'member-portal/user-guides/bg500_nextgen_xvanon',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/otnjikvp',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/phnzzsw0',
                    },
                    {
                        id: 'ownersManual',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/l7a86z5g',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/43afufzn',
                    },
                    {
                        id: 'howTo',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/2i4zsucr',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/2u0tahun',
                    },
                ],
            },
            {
                id: 'deviceFlex',
                image: 'member-portal/user-guides/bg500_nextgen_xvanon',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/5pqh7tgj',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/fwrshxyi',
                    },
                ],
            },
        ],
    },
    [BLOOD_PRESSURE_MONITOR]: {
        mixpanelToggleEvent: 'bp.meter.cta.clicked',
        devices: [
            {
                id: 'htn',
                image: 'member-portal/user-guides/htn_i1p9yv',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://content.teladochealth.com/docs/Livongo-Connected-Blood-Pressure-Monitor-UA-651BLE-LIV-Quick-Start-Guide-EN.pdf',
                        'es-US':
                            'https://content.teladochealth.com/docs/Livongo-Connected-Blood-Pressure-Monitor-UA-651BLE-LIV-Quick-Start-Guide-ES.pdf',
                    },
                ],
            },
            {
                id: 'ht900',
                image: 'member-portal/user-guides/ht900_945_nextgen_fgmmle',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/69mmtlcm',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/vrd64kwz',
                    },
                ],
            },
            {
                id: 'ht945',
                image: 'member-portal/user-guides/ht900_945_nextgen_fgmmle',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/9ugb8o0v',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/irq18cns',
                    },
                ],
            },
            {
                id: 'ht2000',
                image: 'member-portal/user-guides/ht2000_nextgen_l5iayg',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/gcln9ihv',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/5bzc1m81',
                    },
                    {
                        id: 'gettingStarted',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/068dzc1b',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/aoesohd8',
                    },
                    {
                        id: 'manual',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/p9r7gv69',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/wy9i33q0',
                    },
                ],
            },
        ],
    },
    [WEIGHT_SCALE]: {
        mixpanelToggleEvent: 'weight.monitor.cta.clicked',
        devices: [
            {
                id: 'wm1000',
                image: 'member-portal/user-guides/wm1000_nextgen_hdauyk',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/f4zq8j8t',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/1crwr8ne',
                    },
                    {
                        id: 'howTo',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/l34xgp8j',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/v4tvdo2i',
                    },
                ],
            },
            {
                id: 'wm1500',
                image: 'member-portal/user-guides/wm1500_nextgen_axoowx',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/0sl6ix1v',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/8fmh8q0s',
                    },
                    {
                        id: 'howTo',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/l10dsm5y',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/y5e1wuzy',
                    },
                ],
            },
            {
                id: 'wm2000',
                image: 'member-portal/user-guides/wm2000_nextgen_v9bufe',
                manuals: [
                    {
                        id: 'userGuide',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/kh9mmoq8',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/pdcwkjo2',
                    },
                    {
                        id: 'howTo',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/f6p5aza4',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/1d2msaq2',
                    },
                    {
                        id: 'bodyCompBenefits',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/94sjkm80',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/yk0frfkm',
                    },
                    {
                        id: 'biaLearnMore',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/3s5mv30c',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/6h06wwxn',
                    },
                    {
                        id: 'exploreBodyComposition',
                        'en-US':
                            'https://click.teladochealth.com/OIxw/dt0jdxvt',
                        'es-US':
                            'https://click.teladochealth.com/OIxw/my61h9oo',
                    },
                ],
            },
        ],
    },
    allUserGuides: {
        id: 'allGuides',
        'en-US': 'https://click.teladochealth.com/OIxw/vi6qa10m',
        'es-US': 'https://click.teladochealth.com/OIxw/r0cei8t3',
    },
};
